import { BusinessRules } from '../BusinessRules';

const rules: Partial<BusinessRules> = {
  validatePropostaShowDesconto: () => false,
};

export default rules;
